<app-plain-toolbar></app-plain-toolbar>

<div class="hmn-width__full hmn-height__full hmn-background__primary hmn-row">
  <div class="hmn-margin__auto hmn-form__standalone hmn-padding__x4">
    <app-shared-stepper [steps]="steps"></app-shared-stepper>

    <h5 class="hmn-margin__x4-bottom hmn-margin__x8-top">{{ 'AGENT_BUILDER.TITLE' | translate }}</h5>

    <app-agent-builder-form></app-agent-builder-form>
  </div>
</div>

<app-plain-footer></app-plain-footer>
